import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// import { getServerSession } from "next-auth/next";
// import { authOptions } from "@/app/api/auth/[...nextauth]/auth-options";
import { Toaster } from "react-hot-toast";
// import AuthProvider from "@/app/api/auth/[...nextauth]/auth-provider";
import GlobalDrawer from "@/app/shared/drawer-views/container";
import GlobalModal from "@/app/shared/modal-views/container";
import { JotaiProvider, ThemeProvider } from "@/app/shared/theme-provider";
import NextProgress from "@/components/next-progress";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { BrowserRouter } from "react-router-dom";

import Routers from "./routers/routes.tsx";

// styles
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/navigation";

import "@/Connection/connection-hub";

// import "../public/main.js";
import "./index.css";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

export const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
    <StrictMode>
        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
                {/* The rest of your application */}
                <ReactQueryDevtools
                    initialIsOpen={false}
                    buttonPosition="bottom-right"
                />
                {/* <AuthProvider session={await getServerSession(authOptions)}> */}
                <ThemeProvider>
                    <NextProgress />
                    <JotaiProvider>
                        {/* {children} */}
                        <Routers />
                        {/* toast : https://react-hot-toast.com/ */}
                        <Toaster position="top-right" />
                        <GlobalDrawer />
                        <GlobalModal />
                    </JotaiProvider>
                </ThemeProvider>
                {/* </AuthProvider> */}
            </QueryClientProvider>
        </BrowserRouter>
    </StrictMode>,
);
